export const BASE_TELEPORT_SELECTOR = "#teleports";
